var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"headline"},[_c('small',{staticClass:"caption mr-2"},[_vm._v(_vm._s(_vm.car.maker))]),_c('span',[_vm._v(_vm._s(_vm.car.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }